module.exports = __webpack_public_path__ + "img/eMoneyLogo-tron_3.852f7182.svg";